import { FC } from 'react';
import { FilterGroupProps } from './FilterGroup.types';
import { Button, ButtonGroup, Text, Flex, Pill, Icon } from '@/_components';
import styles from './FilterGroup.module.css';

export const FilterGroup: FC<FilterGroupProps> = ({
  children,
  onResetUser,
  onResetRole,
  roleName,
  userName,
}) => {
  if (!roleName) return children;

  return (
    <Flex isColumn={true} className={styles.filterGroup}>
      <Flex
        isBetween={true}
        isYCentered={true}
        gap={4}
        padding={4}
        className={styles.filterGroup__header}
      >
        <Flex isColumn={true} gap={2}>
          {roleName && (
            <Flex>
              <Pill intent="accent" label={roleName} />
            </Flex>
          )}
        </Flex>
        <ButtonGroup align="right">
          <Button
            intent="secondary"
            size="tiny"
            iconLeft="x"
            value="Clear"
            isIconOnly={true}
            onClick={onResetRole}
          />
        </ButtonGroup>
      </Flex>
      <Flex padding={4} isColumn={true} className={styles.filterGroup__content}>
        {userName ? (
          <Flex isBetween={true} gap={4} isYCentered={true}>
            <Flex
              isYCentered={true}
              gap={4}
              className={styles.filterGroup__content__username}
            >
              <Icon name="user-circle" size={20} color="secondary" />
              <Text type="small" isEllipsis={true} fontWeight="semi-bold">
                {userName}
              </Text>
            </Flex>
            <ButtonGroup align="right">
              <Button
                intent="secondary"
                size="tiny"
                iconLeft="x"
                value="Clear"
                isIconOnly={true}
                onClick={onResetUser}
              />
            </ButtonGroup>
          </Flex>
        ) : (
          children
        )}
      </Flex>
    </Flex>
  );
};
